exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cb-widget ._2A8VizwVfWjLmjb_uFSF-b{position:relative}\n", ""]);

// exports
exports.locals = {
	"root": "_2A8VizwVfWjLmjb_uFSF-b"
};